// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TIDt","newExpiryDate":"styles_newExpiryDate__33hNl","footer":"styles_footer__3F9ml"};